import {REHYDRATE} from 'redux-persist/lib/constants';

import {SET_TABLE_PARAMS} from '@actions/actionTypes';
import {mergeRehydrate} from '@reducers/rehydrateUtils';

const initialState = {
};

const tableReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TABLE_PARAMS: {
            const newState = {...state};

            newState[action.params.name] = {
                ...state[action.params.name],
                ...action.params.tableParams,
            };

            return newState;
        }
        case REHYDRATE: {
            return {
                ...state,
                ...mergeRehydrate(action, 'payload.app.table', initialState),
            };
        }
        default:
            return state;
    }
};

export default tableReducer;
